import React from "react";
import { Link } from "react-router-dom";
import useSeo from "../hooks/useSeo";
import useReveal from "../hooks/useReveal";
import { billingPage, seo, business } from "../data/siteData";
import { CreditCard } from "lucide-react";

export default function Billing() {
  useSeo(seo["/billing"].title, seo["/billing"].description);
  useReveal();
  return (
    <>
      <section className="border-b-4 border-[#244aa2] bg-[#f7f7f7] py-12">
        <div className="mr-container">
          <h1 className="mr-h1 text-3xl sm:text-4xl">{billingPage.h1}</h1>
          <p className="mt-3 max-w-2xl text-[#575757]">
            Terms, conditions and privacy information for Mr. Resurface LLC payments.
          </p>
          <Link
            to="/make-a-payment"
            data-testid="billing-make-a-payment-button"
            className="mt-6 inline-flex items-center gap-2 bg-[#a10000] px-7 py-3.5 text-[13px] font-bold uppercase tracking-[0.06em] text-white transition-colors duration-200 hover:bg-[#7d0000]"
          >
            <CreditCard className="h-4 w-4" /> Make a Payment
          </Link>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mr-container">
          <div className="reveal mb-10 flex flex-col items-start gap-4 border border-neutral-200 bg-[#f7f7f7] p-7 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-3">
              <CreditCard className="mt-0.5 h-6 w-6 shrink-0 text-[#a10000]" />
              <p className="text-[15px] text-[#575757]">
                Payments are handled directly with Ernest. Call{" "}
                <a href={`tel:${business.phoneRaw}`} className="font-bold text-[#244aa2] underline">
                  {business.phone}
                </a>{" "}
                or email{" "}
                <a href={`mailto:${business.email}`} className="font-bold text-[#244aa2] underline">
                  {business.email}
                </a>
                .
              </p>
            </div>
          </div>

          <div className="space-y-9">
            {billingPage.sections.map((s) => (
              <div key={s.heading} className="mr-body reveal">
                <h2 className="mr-h2 text-xl sm:text-2xl">{s.heading}</h2>
                <p className="mt-3 text-[15.5px]">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
